import React from 'react'
import { useForm, ValidationError } from '@formspree/react'
import { Grid } from '@mui/material'
import './Contact.css'
import Box from '@mui/material/Box'
import customer from '../../assets/images/customer.png'
import Tag from './../../components/Tag/Tag'
import {useNavigate} from 'react-router-dom'

function Contact () {
  const navigate = useNavigate()
  const [state, handleSubmit] = useForm('xayvdaak')
  if (state.succeeded) {
    return (
      <div>
        <p>Thanks for reaching out</p>
        <button onClick={()=>navigate('/')}>Back to home page</button>
      </div>
    )
  }
  return (
    <div>
      <Tag tagName='contact form' />
      <form onSubmit={handleSubmit} style={{ marginTop: '40px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid container className='form-box'>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <div className='customer'>
                  <img src={customer} alt='customer' />
                </div>
              </Grid>
              <Grid item xs={12} className='form-item'>
                <Grid container>
                  <Grid item xs={12} sm={6} className='form-item-id'>
                    <label htmlFor='First-Name'>
                      First Name <span className='required'>*</span>
                    </label>
                    <br />
                    <input
                      type='text'
                      id='Firt-Name'
                      name='First-Name'
                      placeholder='John'
                      required
                    />
                  </Grid>
                  <Grid xs={12} sm={6}>
                    <label htmlFor='Last-Name'>
                      Last Name <span className='required'>*</span>
                    </label>
                    <br />
                    <input
                      type='text'
                      id='Last-Name'
                      name='Last-Name'
                      placeholder='Smith'
                      required
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item className='form-item' xs={12} sm={12} md={12} lg={12}>
                <label htmlFor='Email'>
                  Email Address<span className='required'>*</span>
                </label>
                <br />
                <input
                  id='email'
                  type='Email'
                  name='Email'
                  placeholder='johnsmith@example.com'
                  required
                />
                <ValidationError
                  prefix='Email'
                  field='Email'
                  errors={state.errors}
                />
              </Grid>

              <Grid item className='form-item' xs={12} sm={12} md={12} lg={12}>
                <label htmlFor='Message'>
                  Message <span className='required'>*</span>
                </label>
                <br />
                <textarea
                  id='message'
                  name='message'
                  placeholder='Compose a message'
                  required
                />
                <ValidationError
                  prefix='message'
                  field='message'
                  errors={state.errors}
                />
              </Grid>

              <Grid item className='form-item' xs={12}>
                <button type='submit' disabled={state.submitting}>
                  Submit
                </button>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            md={6}
            lg={6}
            component={Box}
            display={{ xs: 'none', md: 'block', lg: 'block' }}
          >
            <div className='illustration'></div>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

export default Contact
